import React from 'react';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { Button } from 'antd';
import dayjs from 'dayjs';
import { ExportOutlined } from '@ant-design/icons';
import { ISalesReportSumByMonthRes } from '@/interfaces/report';

interface IProps {
  data: ISalesReportSumByMonthRes[];
  startDate: string;
  endDate: string;
}

const ExcelExport = ({ data, startDate, endDate }: IProps) => {
  const handleExport = async () => {
    // Create a new workbook and add a worksheet
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('SalesReport');

    // Add custom headers with grouping
    worksheet.mergeCells('G1:R1'); // Merge cells for "Personal Info"
    worksheet.getCell('G1').value = startDate;
    worksheet.getCell('G1').alignment = {
      horizontal: 'center',
      vertical: 'middle',
    };
    worksheet.getCell('G1').font = { bold: true, color: { argb: 'FFFFFFFF' } };
    worksheet.getCell('G1').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FF0000FF' }, // Blue background
    };

    worksheet.mergeCells('S1:AD1'); // Merge cells for "Personal Info"
    worksheet.getCell('S1').value = endDate;
    worksheet.getCell('S1').alignment = {
      horizontal: 'center',
      vertical: 'middle',
    };
    worksheet.getCell('S1').alignment = {
      horizontal: 'center',
      vertical: 'middle',
    };
    worksheet.getCell('S1').font = { bold: true, color: { argb: 'FFFFFFFF' } };
    worksheet.getCell('S1').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FF0000FF' }, // Blue background
    };

    // Set column headers (row 2)
    worksheet.getRow(2).values = [
      '#',
      'BU',
      'Customer Name',
      'Ship to',
      'Item Code',
      'Item Name',
      'ม.ค.',
      'ก.พ.',
      'มี.ค.',
      'เม.ย.',
      'พ.ค.',
      'มิ.ย.',
      'ก.ค.',
      'ส.ค.',
      'ก.ย.',
      'ต.ค.',
      'พ.ย.',
      'ธ.ค.',
      'ม.ค.',
      'ก.พ.',
      'มี.ค.',
      'เม.ย.',
      'พ.ค.',
      'มิ.ย.',
      'ก.ค.',
      'ส.ค.',
      'ก.ย.',
      'ต.ค.',
      'พ.ย.',
      'ธ.ค.',
    ];

    worksheet.getRow(2).eachCell(cell => {
      cell.font = { bold: true, color: { argb: 'FFFFFFFF' } }; // White text
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF0000FF' },
      };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
    });

    data.forEach(item => {
      worksheet.addRow([
        item.id,
        item.businessUnitName,
        item.customerName,
        item.shippingAddressName,
        item.productCode,
        item.productName,
        item.mQ1,
        item.mQ2,
        item.mQ3,
        item.mQ4,
        item.mQ5,
        item.mQ6,
        item.mQ7,
        item.mQ8,
        item.mQ9,
        item.mQ10,
        item.mQ11,
        item.mQ12,
        item.mQ13,
        item.mQ14,
        item.mQ15,
        item.mQ16,
        item.mQ17,
        item.mQ18,
        item.mQ19,
        item.mQ20,
        item.mQ21,
        item.mQ22,
        item.mQ23,
        item.mQ24,
      ]);
    });
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, `sales-report-${dayjs().format('YYYY-MM-DD')}.xlsx`);
  };

  return (
    <div>
      <Button type="primary" ghost onClick={handleExport}>
        <ExportOutlined /> Export to Excel
      </Button>
    </div>
  );
};

export default ExcelExport;
